var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"white",attrs:{"hide-details":"","solo":"","dense":"","light":"","clearable":"","label":"Pesquisar","value":_vm.value},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }